import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useDefaultSite } from '@/hooks/useDefaultSite';
import { cn } from '@/lib/utils';
import { Building2, ChevronDown, X } from 'lucide-react';

export function OrganizationName() {
  const { currentSite, handleSiteChange, organization, isLoading, isError } =
    useDefaultSite();

  if (isLoading || isError || !organization) return null;

  const hasRestrictions =
    organization.totalSitesCount != null &&
    organization.sites.length < organization.totalSitesCount;

  const label = currentSite
    ? currentSite.name
    : hasRestrictions
      ? (organization.sites[0]?.name ?? 'Centre')
      : 'Tous les centres';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium transition-colors outline-none',
          currentSite
            ? 'text-slate-700 hover:bg-slate-100'
            : 'text-slate-400 hover:text-slate-600 hover:bg-slate-100',
        )}
      >
        <Building2 className="h-4 w-4 text-slate-400" />
        <span className="max-w-[160px] truncate">{label}</span>
        <ChevronDown className="h-3.5 w-3.5 text-slate-400" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        {!hasRestrictions && currentSite && (
          <DropdownMenuItem
            className="flex items-center gap-2.5 text-slate-500"
            onClick={() => handleSiteChange(null)}
          >
            <X className="h-4 w-4" />
            Tous les centres
          </DropdownMenuItem>
        )}
        {organization.sites.map((site) => (
          <DropdownMenuItem
            key={site.id}
            className={cn(
              'flex items-center gap-2.5',
              currentSite?.id === site.id && 'font-medium text-emerald-700',
            )}
            onClick={() => handleSiteChange(site.id)}
          >
            <Building2
              className={cn(
                'h-4 w-4',
                currentSite?.id === site.id
                  ? 'text-emerald-600'
                  : 'text-slate-400',
              )}
            />
            {site.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
